import SectionHeading from "@/components/SectionHeading";
import Counter from "@/components/Counter";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { imgSrc } from "@/lib/api";
import SEO from "@/components/SEO";

export default function Manufacturing() {
  const { content } = useContent();
  const M = content.manufacturing;

  return (
    <div data-testid="manufacturing-page" className="pt-32">
      <SEO path="/manufacturing" title="Star Aluminium & Alloys · 4,000 MT Manufacturing"
        description="From trading excellence to manufacturing expertise. Victory Aluminium is partnered with Star Aluminium & Alloys — a 4,000 MT/Annum aluminium manufacturing unit serving fabricators across India." />
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 pb-16">
        <SectionHeading eyebrow={M.eyebrow} title={M.title} sub={M.sub} />
      </section>

      <section className="bg-[#0F0F10] text-white">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-20 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {[
            { e: M.capacity_mt, s: " MT", l: "Annual Capacity" },
            { e: M.partners_count, s: "", l: "Founding Partners" },
            { e: M.qc_percent, s: "%", l: "Quality Inspection" },
          ].map((s, i) => (
            <div key={i} className="bg-[#0F0F10] p-10 text-center">
              <div className="text-[#D4AF37] text-5xl md:text-6xl font-display"><Counter end={s.e} suffix={s.s} /></div>
              <div className="mt-3 tracking-eyebrow text-[#9CA3AF]">{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-white py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
          <SectionHeading title="Inside Star Aluminium & Alloys." sub="A fully equipped manufacturing facility supplying billets and extrusion-grade aluminium to fabricators and trading partners across India." />
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {M.visuals.map((v) => (
              <figure key={v.label} className="group overflow-hidden">
                <div className="aspect-[3/4] overflow-hidden">
                  <img src={imgSrc(v.src)} alt={v.label} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
                </div>
                <figcaption className="mt-3 tracking-eyebrow text-[#4B5563]">{v.label}</figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#FAFAFA] py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <span className="tracking-eyebrow text-[#D4AF37]">Why this matters to you</span>
            <h3 className="font-display text-3xl md:text-4xl mt-4 leading-tight">{M.why_title}</h3>
            <p className="mt-5 text-[#4B5563] leading-relaxed">{M.why_body}</p>
            <Link to="/contact" data-testid="mfg-cta" className="mt-8 inline-flex items-center gap-2 btn-charcoal px-7 py-4 text-xs tracking-widest uppercase font-semibold">Talk to our team <ArrowRight className="w-4 h-4" /></Link>
          </div>
          <div className="lg:col-span-6">
            <div className="grid grid-cols-2 gap-3">
              {M.bullets.map((b) => (
                <div key={b.title} className="bg-white border border-[#E5E7EB] p-5">
                  <div className="font-display text-lg">{b.title}</div>
                  <div className="text-sm text-[#4B5563] mt-1">{b.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
